import { memo, useEffect, useState } from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import { useHistory, useLocation } from "react-router-dom";
import { withNamespaces } from "react-i18next";

const TABS_LINKS = [
    {
        key: "users",
        title: "Users",
    },
    {
        key: "functions",
        title: "Functions",
    },
];

const Tabs = memo(({ t }) => {
    const [activeTab, setActiveTab] = useState("");
    const history = useHistory();
    const location = useLocation();

    const isActiveTab = (currentTab, tab) => currentTab === tab;

    useEffect(() => {
        const tabKey = new URLSearchParams(location.search).get("tab");
        const tab = TABS_LINKS.find((item) => item.key === tabKey)?.key;

        if (!tab) {
            history.push({
                search: "?tab=users",
            });
        } else {
            setActiveTab(tab);
        }
    }, [location.search, history]);

    return (
        <div
            style={{
                backgroundColor: "#D1D2D6",
            }}
        >
            <Nav tabs className="custom-style-1">
                {TABS_LINKS.map((link) => {
                    return (
                        <NavItem
                            className={isActiveTab(activeTab, link.key) ? "active" : ""}
                            key={link.key}
                        >
                            <NavLink
                                className={isActiveTab(activeTab, link.key) ? "active" : ""}
                                onClick={() =>
                                    history.push({
                                        search: `?tab=${link.key}`,
                                    })
                                }
                            >
                                {t(link.title)}
                            </NavLink>
                        </NavItem>
                    );
                })}
            </Nav>
        </div>
    );
});

export default withNamespaces()(Tabs);
